module.exports = __webpack_public_path__ + "img/xlsx-icon.03db4a9e.png";